import React from 'react';
import Nouislider from 'nouislider-react';
import debounce from 'lodash/debounce';

import { SearchContext } from './search-context';
import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';
import Icon from '../../ui/components/icon';
import Tooltip from '../../shared/components/tooltip';
import 'nouislider/distribute/nouislider.css';
import '../css/search-range-filter.less';

class SearchRangeFilter extends React.Component {

	static defaultProps = {
		format: {
			// 'to' the formatted value. Receives a number.
			to: function (value) {
				return Math.floor(value);
			},
			// 'from' the formatted value.
			// Receives a string, should return a number.
			from: function (value) {
				return Math.floor(value);
			}
		},
		currencySymbol: '$'
	}
	constructor(props) {
		super(props);
		this.state = {
			expand: props.defaultExpanded,
			sliding: false,
			min: 0,
			max: 10
		};
		this.handleChange = this.handleChange.bind(this);
		this.toggleMenu = this.toggleMenu.bind(this);
	}

	handleChange(updateQuery) {
		const { field } = this.props;
		return (data) => {
			let min = data[0];
			let max = data[1];
			updateQuery('replace', { [`${field}`]: [min, max] });
			this.setState({
				sliding: false
			})
		}
	}

	setMin = (updateQuery, max) => {
		const { field, currencySymbol } = this.props;
		return (e) => {
			const { target } = e;
			let { value } = target;
			value = Helpers.convertPriceToNumber(value.replace(currencySymbol, ''));
			let queryValue = [value * 1, max];
			updateQuery('replace', { [`${field}`]: queryValue });
		}
	}

	setMax = (updateQuery, min) => {
		const { field, currencySymbol } = this.props;
		return (e) => {
			const { target } = e;
			let { value } = target;
			value = Helpers.convertPriceToNumber(value.replace(currencySymbol, ''));
			let queryValue = [min, value * 1];
			updateQuery('replace', { [`${field}`]: queryValue });
		}
	}

	toggleMenu = () => {
		this.setState({
			expand: !this.state.expand
		});
	};

	onSlide = (render, handle, value) => {
		let [min, max] = value;
		this.setState({
			sliding: true,
			min,
			max
		});
	}

	render() {
		let { displayName, format, field, minRange, maxRange, description, isV2, currencySymbol } = this.props;
		let { sliding, min: stateMin, max: stateMax } = this.state;

		return (
			<SearchContext.Consumer>
				{
					({ updateQuery, aggregations, query }) => {
						//if a field is provided use value from query
						let [min = minRange, max = maxRange] = (query[field] || []);
						let displayMin = sliding ? stateMin : min;
						let displayMax = sliding ? stateMax : max;


						return (<div className={`filter-group${this.state.expand ? ' expanded' : ' closed'}`}>
							<h3 className='filter-header' onClick={this.toggleMenu}>
								{description && <Tooltip ariaLabel={description} displayOn='click'>{description}</Tooltip>}
								{displayName}
								<span className='arrow'></span>
								<Icon name={this.state.expand ? 'minus_m' : 'plus'} size={20} />
							</h3>
							<div className='price-slider'>
								{isV2 && <input key={displayMin} className='min'
									defaultValue={Helpers.formatCurrency(displayMin, currencySymbol, true, true)}
									onChange={this.setMin(debounce(updateQuery, 350), max)} />}
								{isV2 && this.state.expand && <Icon name={'minus_m'} size={15} />}
								{isV2 && <input key={displayMax} className='max'
									defaultValue={Helpers.formatCurrency(displayMax, currencySymbol, true, true)}
									onChange={this.setMax(debounce(updateQuery, 350), min)} />}
								<Nouislider
									onChange={this.handleChange(updateQuery)}
									onSlide={this.onSlide}
									range={{ min: minRange, max: maxRange + (minRange === maxRange ? 1 : 0) }}
									start={[min, max]}
									format={format}
									connect
								/>
								{!isV2 && <div className='min'>{Helpers.formatCurrency(displayMin, currencySymbol, true, true)}</div>}
								{!isV2 && <div className='max'>{Helpers.formatCurrency(displayMax, currencySymbol, true, true)}</div>}
							</div>
						</div>);
					}
				}
			</SearchContext.Consumer>
		);
	}
}


export default withError(SearchRangeFilter)